import { createSelector } from 'reselect';
import { selectInstancePublishStatus, selectContentTypeColumns, selectInstanceValues, selectHsNameDefaultValue } from './instanceEditSelectors';
import { getSettingsProperties, getSettingsSectionName, getIsStandardColumn } from '../../utils/hubdb';
import I18n from 'I18n';
export const selectPublishType = createSelector([selectInstancePublishStatus], publishState => {
  if (publishState === 'PUBLISHED') {
    return 'update';
  }
  return 'publish';
});
export const selectPublishValidationErrors = createSelector([selectContentTypeColumns, selectInstanceValues, selectHsNameDefaultValue], (schema, instanceValues, defaultName) => {
  const errors = {};
  const settingsFields = schema && getSettingsProperties(schema);
  if (instanceValues && settingsFields) {
    settingsFields.forEach(field => {
      const sectionName = getSettingsSectionName(field.name);
      // Additional logic to deem hs_path invalid if it is a temporary slug
      const isHsPath = field.name === 'hs_path';
      const isTemporarySlug = isHsPath && instanceValues[field.name].includes('temporary-slug');
      const isHsName = field.name === 'hs_name';
      const isDefaultName = isHsName && instanceValues[field.name] === defaultName;
      if (field.isRequired && !instanceValues[field.name] || isTemporarySlug || isDefaultName) {
        if (getIsStandardColumn(field.name)) {
          errors[field.name] = {
            pane: 'settings',
            type: 'required',
            fieldSchema: {
              title: I18n.text(`StructuredContentLib.standardColumns.${field.name}.publishValidationError`)
            },
            settingsModalQuery: `${sectionName}.${[field.name]}`
          };
        } else {
          errors[field.name] = {
            pane: 'settings',
            type: 'required',
            fieldSchema: {
              title: I18n.text(`StructuredContentLib.customColumn.publishValidationError`, {
                label: field.label
              })
            },
            settingsModalQuery: `${sectionName}.${[field.name]}`
          };
        }
      }
    });
  }
  return errors;
});